<template>
  <section class="skill-dive-hero">
    <div class="skill-dive-hero__content">
      <div class="skill-dive-hero__logo">
        <img
          :src="skillDiveLogoBadge"
          alt="Skill Dive Experience"
          class="skill-dive-hero__logo-icon"
        />
      </div>
      <div class="skill-dive-hero__title">Unlock Potential with Skill Dive</div>
      <div class="skill-dive-hero__intro">
        Introducing a better way to prepare for real-world scenarios - immersive, curated labs that
        take you deeper into your training goals.
      </div>
      <div v-if="!isSkillDivePreSalePage" class="skill-dive-hero__learn-more">
        <router-link :to="{ name: 'skill-dive' }" class="btn btn--primary btn--full-mobile">
          Learn more
        </router-link>
      </div>
    </div>
    <div
      :class="[
        'skill-dive-hero__icon',
        isSkillDivePreSalePage && 'skill-dive-hero__icon--pre-sale-page',
      ]"
    ></div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import skillDiveLogo from '@/assets/images/hero-section/skill-dive/skill-dive-logo.png'
import skillDiveIcon from '@/assets/images/hero-section/skill-dive/skill-dive.png'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'SkillDiveHeroSection',
  mixins: [routesRules],
  data() {
    return {
      skillDiveLogoBadge: skillDiveLogo,
    }
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
    }),
    ...mapGetters({
      isBusinessUser: 'business/isBusinessUser',
    }),
    skillDiveBadge() {
      return skillDiveIcon
    },
  },
}
</script>

<style lang="scss" scoped>
.skill-dive-hero {
  width: 100%;
  max-width: 1120px;
  padding: 50px 20px 20px 20px;
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  position: relative;
  @include desktop {
    margin: 85px auto 105px auto;
    padding: 0;
  }
  &__content {
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 10px;
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
    }
    @include desktop {
      width: 95%;
    }
  }
  &__logo {
    &-icon {
      width: 230px;
      @include tablet-ipad-air-and-mini-portrait {
        width: 260px;
      }
      @include tablet {
        width: 260px;
      }
      @include desktop {
        width: 325px;
      }
    }
  }
  &__title {
    font-family: var(--font-bold);
    font-size: rem(32px);
    line-height: rem(38px);
    font-style: normal;
    font-weight: 700;
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 20px;
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 20px;
    }
    @include xs-desktop {
      white-space: nowrap;
    }
  }
  &__intro {
    font-size: rem(14px);
    font-weight: 450;
    line-height: rem(20px);
    @include tablet-ipad-air-and-mini-portrait {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
      width: 60%;
      margin-bottom: 20px;
    }
    @include tablet {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
      width: 60%;
      margin-bottom: 20px;
    }
    @include desktop {
      width: 55%;
    }
  }
  &__icon {
    background-position: center right;
    background-image: var(--skill-dive-logo-svg);
    background-repeat: no-repeat;
    background-size: contain;
    width: 225px;
    height: 180px;
    position: absolute;
    bottom: 240px;
    right: -25px;
    @include xs-desktop {
      bottom: 180px;
    }
    @include mobile {
      width: 450px;
      height: 450px;
      bottom: 35px;
      right: -160px;
    }
    @include desktop {
      width: 570px;
      height: 570px;
      bottom: -85px;
      right: 0;
    }
    &--pre-sale-page {
      bottom: 185px;
      @include xs-desktop {
        bottom: 120px;
      }
      @include mobile {
        bottom: -25px;
      }
      @include tablet {
        bottom: -35px;
      }
      @include desktop {
        bottom: -145px;
      }
    }
  }
}
</style>
